/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
import { getUsers, resendInvite  } from 'state/actions/accountState/account_data';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import Users from 'pages/dashboard/account/users/users';



/* ========== ~~~~~~~~~~ BUTTON : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ( { accountData, sessionStatus } ) =>({
    users: accountData.users,
    accountUUID: sessionStatus.accountUUID,
    userUUID: sessionStatus.userUUID,
    resendingInvite: accountData.resendingInvite
});

// map actions
const mapDispatchToProps = dispatch => ({
    getUsers: (accountUUID)=> dispatch(getUsers(accountUUID)),
    resendInvite: userUUID => dispatch(resendInvite(userUUID))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Users);